import React from 'react';
import '../../App.css';
import { Link, NavLink } from 'react-router';
import ResearchSidebar from '../../Components/ResearchSidebar';

const Research = () => {
  return (
    <main className="dashboard-layout">
      
      {/* Sidebar */}
      <ResearchSidebar />

      {/* Main Content */}
      <div className="dashboard-content">
        <h1 className="page-title">Researcher Dashboard</h1>
        
        <div className="dashboard-grid">
          
          {/* Card 1: The Mission */}
          <section className="dash-card mission-card">
            <h2>Research Goals</h2>
            <p>
              This platform is a data collection resource designed to mimic online food retail environments. 
              Our goal is to study food choice behavior and allow you to customize product presentation.
            </p>
            <p>
              <strong>Key Motivation:</strong> To use advancements in technology to examine novel options 
              to promote healthier foods and combat diet-related diseases.
            </p>
          </section>

          {/* Card 2: Capabilities */}
          <section className="dash-card info-card">
            <h2>Experiment Capabilities</h2>
            <p>In future updates, you will be able to configure:</p>
            <ul>
              <li><strong>Product Display:</strong> Customize which food product categories are included and what information is shown.</li>
              <li><strong>Interactions:</strong> Control how participants interact via filters, product subsets, and search tools.</li>
              <li><strong>Conditions:</strong> Implement different experimental conditions, such as specific messaging or labels.</li>
            </ul>
          </section>

          {/* Card 3: Quick Actions */}
          <section className="dash-card action-card">
            <h2>Quick Actions</h2>
            <div className="action-buttons">
              <Link to="/research-portal/surveys" className="action-btn">Manage Surveys</Link>
              <Link to="/research-portal/data" className="action-btn">View Collected Data</Link>
            </div>
            <p className="note">
              * Note: Detailed experiment configuration tools are currently in development.
            </p>
          </section>

        </div>
      </div>
    </main>
  );
};

export default Research;